import { GenericCampaignCreationPropertiesType } from '@ads/front-core/api'

export type CreationFormatType = 'FLAT_FORMAT' | 'RICH_MEDIA'

export const mixCreations: GenericCampaignCreationPropertiesType[] = [
  'RECTANGLE_300x250',
  'MEGA_DOUBLE_BILLBOARD_970x300',
  'DOUBLE_BILLBOARD_750x200',
  'HALFPAGE_300x600',
  'TRIPLE_BILLBOARD_750x300',
  'BANNER_300x100',
  'WIDEBOARD_970x200',
  'BILLBOARD_750x100',
  'SCALABLE_XL_BANNER_600x400',
]
